module.exports = __webpack_public_path__ + "static/img/yellow.9c6cd6e1.png";